import { FadeUp, Eyebrow } from "./Reveal";

const STEPS = [
  {
    n: "01",
    t: "Concept",
    d: "Understanding the brief, the site and how you live. Smart zoning without walls, open kitchen integration, visual expansion and functional flow — every inch intentionally designed before a single line is drawn.",
    testid: "process-step-01-concept",
  },
  {
    n: "02",
    t: "Design",
    d: "Detailed layouts, 3D views and a deliberate material matrix — Italian marble, custom CNC relief panels, charcoal, pastel laminates, mirror and warm brass in intentional harmony.",
    testid: "process-step-02-design",
  },
  {
    n: "03",
    t: "Execute",
    d: "Turnkey execution with rigorous quality control, delivered to an absolute handover date. At Knights Court: designed, built and handed over in 4 months.",
    testid: "process-step-03-execute",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-methodology-section" className="py-24 lg:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <FadeUp>
          <Eyebrow>The Method</Eyebrow>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ink mt-5 max-w-2xl leading-[1.05]">
            Concept. Design. Execute.
          </h2>
        </FadeUp>

        <div className="grid lg:grid-cols-3 gap-4 mt-16">
          {STEPS.map((s, i) => (
            <FadeUp key={s.n} delay={i * 0.08}>
              <div
                data-testid={s.testid}
                className="group border border-hairline bg-cream p-9 lg:p-10 h-full hover:border-brass/60 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="font-serif text-7xl text-brass/25 group-hover:text-brass/60 transition-colors duration-500">
                  {s.n}
                </div>
                <h3 className="font-serif text-2xl lg:text-3xl text-ink mt-6">{s.t}</h3>
                <p className="text-sm leading-relaxed text-taupe mt-4">{s.d}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
